import store from '../store';

/**
 * returns the center for the passed in center name, abbrev or tag
 * @param {string} center name to search for
 * @returns option object
 */
export function getCenterId(center) {
    const foundCenter = store.getters.companyCenters.find(companyCenter => {
        return (companyCenter.center_abbrev === center
            || companyCenter.center_tag === center
            || companyCenter.center_name === center);
    });
    return foundCenter ? foundCenter.center_id : undefined;
}